var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFeedbackLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.856 3.25c1.966 0 3.181 2.146 2.17 3.832l-.7 1.168h1.243c2.653 0 4.467 2.68 3.482 5.143l-1.6 4a3.75 3.75 0 0 1-3.482 2.357H7A3.75 3.75 0 0 1 3.25 16v-4A3.75 3.75 0 0 1 7 8.25h1.639l3.24-4.05a2.53 2.53 0 0 1 1.976-.95m0 1.5c-.313 0-.61.142-.805.387L9.75 9.263v8.987h5.219c.92 0 1.747-.56 2.089-1.414l1.6-4A2.25 2.25 0 0 0 16.57 9.75H14a.75.75 0 0 1-.644-1.136l1.383-2.303a1.03 1.03 0 0 0-.884-1.561M4.75 16A2.25 2.25 0 0 0 7 18.25h1.25v-8.5H7A2.25 2.25 0 0 0 4.75 12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFeedbackLike);
export default __webpack_public_path__ + "static/media/user-feedback-like.d02c616cf6b0b31b41893fec84d90500.svg";
export { ForwardRef as ReactComponent };